module.exports = __webpack_public_path__ + "static/img/报警.4e9aa16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/商务车（含面包）/报警.png
// module id = 7nEU
// module chunks = 76